export const EnergyIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M13 2L3 14H12L11 22L21 10H12L13 2Z"
      fill="url(#energy-gradient)"
      stroke="url(#energy-gradient)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="energy-gradient" x1="3" y1="14" x2="21" y2="10">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#34d399" />
      </linearGradient>
    </defs>
  </svg>
)

export const SleepIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
      fill="url(#sleep-gradient)"
      stroke="url(#sleep-gradient)"
      strokeWidth="1.5"
    />
    <path
      d="M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z"
      fill="white"
    />
    <defs>
      <linearGradient id="sleep-gradient" x1="11.21" y1="3" x2="21" y2="12.79">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
  </svg>
)

export const LongevityIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" fill="url(#longevity-gradient)" strokeWidth="1.5" />
    <circle cx="12" cy="12" r="6" fill="white" />
    <path
      d="M12 6V12L16 14"
      stroke="url(#longevity-gradient)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient id="longevity-gradient" x1="2" y1="2" x2="22" y2="22">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
  </svg>
)

export const BiomarkerIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2L2 7L12 12L22 7L12 2Z"
      fill="url(#biomarker-gradient)"
      stroke="url(#biomarker-gradient)"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M2 17L12 22L22 17"
      stroke="url(#biomarker-gradient)"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M2 12L12 17L22 12"
      stroke="url(#biomarker-gradient)"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="biomarker-gradient" x1="2" y1="2" x2="22" y2="22">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
  </svg>
)

export const AnalyticsIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M3 3V21H21"
      stroke="url(#analytics-gradient)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7 16L12 11L16 15L21 10"
      stroke="url(#analytics-gradient)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="7" cy="16" r="2" fill="url(#analytics-gradient)" />
    <circle cx="12" cy="11" r="2" fill="url(#analytics-gradient)" />
    <circle cx="16" cy="15" r="2" fill="url(#analytics-gradient)" />
    <circle cx="21" cy="10" r="2" fill="url(#analytics-gradient)" />
    <defs>
      <linearGradient id="analytics-gradient" x1="3" y1="3" x2="21" y2="21">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
  </svg>
)

export const KnowledgeIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
      stroke="url(#knowledge-gradient)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 2H20V20H6.5A2.5 2.5 0 0 1 4 17.5V4.5A2.5 2.5 0 0 1 6.5 2Z"
      fill="url(#knowledge-gradient)"
      stroke="url(#knowledge-gradient)"
      strokeWidth="1.5"
    />
    <path d="M9 7H17M9 11H17M9 15H14" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <defs>
      <linearGradient id="knowledge-gradient" x1="4" y1="2" x2="20" y2="20">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
  </svg>
)

export const TargetIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="url(#target-gradient)" strokeWidth="2" />
    <circle cx="12" cy="12" r="6" stroke="url(#target-gradient)" strokeWidth="2" />
    <circle cx="12" cy="12" r="2" fill="url(#target-gradient)" />
    <defs>
      <linearGradient id="target-gradient" x1="2" y1="2" x2="22" y2="22">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
  </svg>
)

export const RocketIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M4.5 16.5C4.5 16.5 6 14 8 12C6 10 4.5 7.5 4.5 7.5C4.5 7.5 7 9 9 11C11 9 13.5 7.5 13.5 7.5C13.5 7.5 12 10 10 12C12 14 13.5 16.5 13.5 16.5C13.5 16.5 11 15 9 13C7 15 4.5 16.5 4.5 16.5Z"
      fill="url(#rocket-gradient)"
    />
    <path
      d="M12 3L13 7L17 8L13 9L12 13L11 9L7 8L11 7L12 3Z"
      fill="url(#rocket-gradient)"
    />
    <defs>
      <linearGradient id="rocket-gradient" x1="4.5" y1="3" x2="17" y2="16.5">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#34d399" />
      </linearGradient>
    </defs>
  </svg>
)

export const SunIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="5" fill="url(#sun-gradient)" />
    <path
      d="M12 1V3M12 21V23M4.22 4.22L5.64 5.64M18.36 18.36L19.78 19.78M1 12H3M21 12H23M4.22 19.78L5.64 18.36M18.36 5.64L19.78 4.22"
      stroke="url(#sun-gradient)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient id="sun-gradient" x1="1" y1="1" x2="23" y2="23">
        <stop offset="0%" stopColor="#f59e0b" />
        <stop offset="100%" stopColor="#fbbf24" />
      </linearGradient>
    </defs>
  </svg>
)

export const WalkIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="4" r="2" fill="url(#walk-gradient)" />
    <path
      d="M12 6V16M8 10L12 6L16 10M8 18L12 14L16 18"
      stroke="url(#walk-gradient)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="walk-gradient" x1="8" y1="4" x2="16" y2="18">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
  </svg>
)

export const PillIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <rect x="8" y="10" width="8" height="4" rx="2" fill="url(#pill-gradient)" />
    <path
      d="M8 12C8 10.8954 8.89543 10 10 10H14C15.1046 10 16 10.8954 16 12C16 13.1046 15.1046 14 14 14H10C8.89543 14 8 13.1046 8 12Z"
      fill="url(#pill-gradient)"
    />
    <defs>
      <linearGradient id="pill-gradient" x1="8" y1="10" x2="16" y2="14">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
  </svg>
)

export const ActivityIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M22 12H18L15 21L9 3L6 12H2"
      stroke="url(#activity-gradient)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="activity-gradient" x1="2" y1="3" x2="22" y2="21">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
  </svg>
)

export const RecoveryIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.57831 8.50903 2.99871 7.05 2.99871C5.59096 2.99871 4.19169 3.57831 3.16 4.61C2.1283 5.64169 1.54871 7.04097 1.54871 8.5C1.54871 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7564 11.2728 22.0329 10.6054C22.3095 9.93789 22.4518 9.22248 22.4518 8.5C22.4518 7.77752 22.3095 7.0621 22.0329 6.39464C21.7564 5.72718 21.351 5.12075 20.84 4.61Z"
      fill="url(#recovery-gradient)"
    />
    <defs>
      <linearGradient id="recovery-gradient" x1="1.55" y1="3" x2="22.45" y2="21.23">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
  </svg>
)

export const PlanIcon = ({ className = 'w-6 h-6', active = false }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5M9 12H15M9 16H13"
      stroke={active ? 'url(#plan-active-gradient)' : 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      fill={active ? 'url(#plan-active-gradient)' : 'none'}
    />
    <defs>
      <linearGradient id="plan-active-gradient" x1="5" y1="3" x2="19" y2="21">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#34d399" />
      </linearGradient>
    </defs>
  </svg>
)

export const MaterialsIcon = ({ className = 'w-6 h-6', active = false }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
      stroke={active ? 'url(#materials-active-gradient)' : 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 2H20V20H6.5A2.5 2.5 0 0 1 4 17.5V4.5A2.5 2.5 0 0 1 6.5 2Z"
      fill={active ? 'url(#materials-active-gradient)' : 'none'}
      stroke={active ? 'url(#materials-active-gradient)' : 'currentColor'}
      strokeWidth="1.5"
    />
    <path
      d="M9 7H17M9 11H17M9 15H14"
      stroke={active ? 'white' : 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient id="materials-active-gradient" x1="4" y1="2" x2="20" y2="20">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
  </svg>
)

export const ProfileIcon = ({ className = 'w-6 h-6', active = false }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <circle
      cx="12"
      cy="8"
      r="4"
      fill={active ? 'url(#profile-active-gradient)' : 'none'}
      stroke={active ? 'url(#profile-active-gradient)' : 'currentColor'}
      strokeWidth="2"
    />
    <path
      d="M6 21C6 17.6863 8.68629 15 12 15C15.3137 15 18 17.6863 18 21"
      stroke={active ? 'url(#profile-active-gradient)' : 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      fill={active ? 'url(#profile-active-gradient)' : 'none'}
    />
    <defs>
      <linearGradient id="profile-active-gradient" x1="6" y1="8" x2="18" y2="21">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#34d399" />
      </linearGradient>
    </defs>
  </svg>
)

export const TrainerIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="6" r="3" fill="url(#trainer-gradient)" />
    <path
      d="M12 9V21M8 13L12 9L16 13M8 17L12 13L16 17"
      stroke="url(#trainer-gradient)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="trainer-gradient" x1="8" y1="6" x2="16" y2="21">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
  </svg>
)

export const NutritionistIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="8" fill="url(#nutritionist-gradient)" />
    <circle cx="12" cy="12" r="4" fill="white" />
    <path
      d="M12 4V8M12 16V20M4 12H8M16 12H20"
      stroke="url(#nutritionist-gradient)"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient id="nutritionist-gradient" x1="4" y1="4" x2="20" y2="20">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#34d399" />
      </linearGradient>
    </defs>
  </svg>
)

export const DoctorIcon = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2L2 7L12 12L22 7L12 2Z"
      fill="url(#doctor-gradient)"
      stroke="url(#doctor-gradient)"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M2 17L12 22L22 17"
      stroke="url(#doctor-gradient)"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M2 12L12 17L22 12"
      stroke="url(#doctor-gradient)"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="2" fill="white" />
    <defs>
      <linearGradient id="doctor-gradient" x1="2" y1="2" x2="22" y2="22">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
  </svg>
)
